import React from 'react';
import { ThemeProvider } from '@material-ui/styles';

import theme from './theme';
import Routes from './Routes';
import UserProfile from './UserProfile';
import JournalMarche from './JournalMarche';
import { useServiceWorker } from './hooks/useServiceWorker';
import useAuthGuard from './hooks/useAuthGuard';
import { bootstrapChartjs } from './bootstrap/chartjs.bootstrap';
import { bootstrapValidators } from './bootstrap/validators.bootstrap';

import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.scss';

bootstrapChartjs();
bootstrapValidators();

const App = () => {
    useServiceWorker();
    useAuthGuard();

    return (
        <ThemeProvider theme={theme}>
            <Routes userProfile={UserProfile} journalMarket={JournalMarche} />
        </ThemeProvider>
    );
};

export default App;
